var map = {
	"./v_accept.svg": "afc3",
	"./v_clear.svg": "4c88",
	"./v_delete.svg": "73ab",
	"./v_denied.svg": "8128",
	"./v_pass.svg": "03ba",
	"./v_print.svg": "6414",
	"./v_skud.svg": "8cdf",
	"./v_solvo.svg": "c85d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3435";